<template>
  <div class="">
    <Header class="" />
    <div class="fixed-background">
      <div class="container pt-3">
        <router-view></router-view>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from "./components/header/GuestHeader.vue";
import Footer from "./components/footer/Footer.vue";
export default {
  components: {
    Header,
    Footer,
  },
};
</script>

<style scoped>
.fixed-background {
  background-image: url("./assets/jkt/building.gif");
  background-attachment: fixed;
  background-size: cover;
  background-position: center;
  min-height: 100vh;
}
</style>
